<div class="p-5 text-center inprogressConsent">
    <img src="assets/img/svg/inprogress.svg" width="158px" height="143px">
    <h1 class="my-3">In Progress</h1>
    <h3>Consent approved successfully!</h3>
    <div class="text-center mt-3">
        <p class="mb-0">Bank data retrieval in progress.</p>
        <p>Thank you for your patience. Please return shortly for updates</p>
    </div>
</div>